module.exports = __webpack_public_path__ + "media/images/front/icons/search-aac54bce545ed4e3863134c59664e3ac.svg";